import Dce from "dce-engine/lib/decorators/Dce";
import DceComponent from "dce-engine/lib/engine/DceComponent";
import DceHTMLElement from "dce-engine/lib/types/DceHTMLElement";
import HttpRoute from "../../../dce-ajax/lib/utils/HttpRoute";
import {DceAjax} from "dce-ajax";
import {CancelTokenSource} from "axios";
import {Event} from "jquery";

interface ListSearchScrollToProps {
}

@Dce("ListSearchScrollTo")
export default class AutosizeTextarea extends DceComponent<ListSearchScrollToProps> {
    private input: HTMLInputElement;
    private list: HTMLElement;

    private selected: HTMLElement = null;

    constructor(elem: DceHTMLElement, props: ListSearchScrollToProps) {
        super(elem, props);

        this.input = elem.querySelector('input[data-role="input"]');
        this.list = elem.querySelector('[data-role="list"]');

        this.input.addEventListener('input', ev => {
            console.log("AAAAAAAAAAAAAAAAA", this.input.value);
            this.scrollTo(this.input.value);
        });

        this.input.addEventListener('keydown', (e) => {

            // "ArrowRight", "ArrowLeft", "ArrowUp", or "ArrowDown"
            if(e.key == "ArrowDown"){

                if(null == this.selected){
                    this.setSelected(this.list.firstElementChild as HTMLElement, "nearest");
                }else{
                    if(this.selected.nextElementSibling){
                        this.setSelected(this.selected.nextElementSibling as HTMLElement, "nearest");
                    }
                }

                e.preventDefault();
                return;
            }

            if(e.key == "ArrowUp"){

                if(null == this.selected){
                    this.setSelected(this.list.firstElementChild as HTMLElement, "nearest");
                }else{
                    if(this.selected.previousElementSibling){
                        this.setSelected(this.selected.previousElementSibling as HTMLElement, "nearest");
                    }
                }

                e.preventDefault();
                e.stopPropagation();
                return;
            }

            if(e.key == "Enter"){
                if(null != this.selected){

                    var evt = new MouseEvent('click', {
                        bubbles: true,
                        cancelable: true,
                        view: window
                    });

                    this.selected.dispatchEvent(evt);
                }
            }


        });

    }

    public scrollTo(val:string){

        let children = Array.from(this.list.children);

        let lval = val.toLowerCase();

        let element: Element = null;

        for (const child of children) {

            console.log(child.textContent.toLowerCase().trim(), child.textContent.toLowerCase().trim().indexOf(lval));

            if(child.textContent.toLowerCase().trim().indexOf(lval) == 0){
                element = child;
                break;
            }
        }

        if(null == element){

            this.setSelected(this.list.firstElementChild as HTMLElement);

        }else{

            this.setSelected(element as HTMLElement);

        }

    }

    private setSelected(element: HTMLElement, pos: ScrollLogicalPosition = "start"){
        (element as HTMLElement).scrollIntoView({
            behavior: "smooth",
            block: pos
        });

        let s = this.list.querySelector('.selected');
        if(s){
            s.classList.remove("selected");
        }

        element.classList.add("selected");
        this.selected = element  as HTMLElement;
    }


}
